export default __webpack_public_path__ + "assets/reference-background.0a7adc4d.png";